var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marketing_signup_form"},[_c('input',{staticClass:"marketing_checkbox",attrs:{"type":"checkbox","name":_vm.text,"id":_vm.id},domProps:{"checked":_vm.value},on:{"change":_vm.onChange}}),_c('label',{class:_vm.labelClass,attrs:{"for":_vm.id}},[_vm._v(" "+_vm._s(_vm.lang.company[_vm.translatedText])+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }